import { defineStore } from 'pinia';
import { DataSet } from 'vis-data';
import { computed, ref } from 'vue';

export const usePlanStore = defineStore('plan', () => {
  const saving = ref(false);
  const loading = ref(true);
  const isDirty = ref(false);

  const id = ref();
  const name = ref();
  const lastPublishedAt = ref();
  const logo = ref();
  const introduction = ref();
  const executiveSummary = ref();
  const conclusion = ref();
  const vision = ref();
  const nodes = ref(new DataSet([]));
  const edges = ref(new DataSet([]));
  const district = ref();
  // const hasChanged = ref(false);

  const selectedFramework = ref(null);
  const formData = computed(() => {
    return {
      name: name.value,
      introduction: introduction.value,
      executiveSummary: executiveSummary.value,
      conclusion: conclusion.value,
      vision: vision.value,
      nodes: nodes.value.get(),
      edges: edges.value.get(),
    };
  });

  // watch(logo, () => {
  //   if (loading.value === false) {
  //     hasChanged.value = true;
  //   }
  // }, { deep: true });
  //
  // watch(formData, (newValue, oldValue) => {
  //   /*
  //    * Only check for changes after the API call has been made to fetch the plan's data.
  //    * This is needed, because the plan's data gets set on the store and changes should only
  //    * be watched for after the plan's data has been set.
  //    *
  //    * The use of `Object.keys(diff())` is to make sure that the new object that is returned from
  //    * the `computed()` function above isn't detected as a new change if there is nothing different
  //    * between the new and old value; the new and old values will always be different, in terms of
  //    * reference, because `computed()` will always return a new object.
  //    *
  //    * However, `formData` should only be updating when there is a change, but `diff()` is showing that
  //    * there hasn't been a change, but `watch()` shows that there is, which means that diffing the objects
  //    * shouldn't be necessary, but for some reason, it is.
  //    */
  //   if (!loading.value && Object.keys(diff(oldValue, newValue)).length > 0) {
  //     hasChanged.value = true;
  //   }
  // }, { deep: true });

  return {
    saving,
    loading,
    isDirty,
    id,
    name,
    vision,
    introduction,
    executiveSummary,
    conclusion,
    lastPublishedAt,
    logo,
    nodes,
    edges,
    formData,
    selectedFramework,
    district,
    // hasChanged,
  };
});
